import { render, staticRenderFns } from "./ProjectBoard.vue?vue&type=template&id=d44bb33e&scoped=true"
import script from "./ProjectBoard.vue?vue&type=script&lang=js"
export * from "./ProjectBoard.vue?vue&type=script&lang=js"
import style0 from "./ProjectBoard.vue?vue&type=style&index=0&id=d44bb33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44bb33e",
  null
  
)

export default component.exports